(() => {
  if (customElements.get('footer-accordion')) {
    return;
  }

  const AccordionElement = customElements.get('accordion-element');

  if (!AccordionElement) {
    return;
  }

  class FooterAccordion extends AccordionElement {
    constructor() {
      super();

      this.onResize = this.onResize.bind(this);
    }

    connectedCallback() {
      super.connectedCallback();

      this.onResize();

      this.attachEvents();
    }

    disconnectedCallback() {
      super.disconnectedCallback();

      this.detachEvents();
    }

    attachEvents() {
      super.attachEvents();

      this.debouncedResize = debounce(this.onResize, 300);

      window.addEventListener('resize', this.debouncedResize);
    }

    detachEvents() {
      super.detachEvents();

      window.removeEventListener('resize', this.debouncedResize);
    }

    onResize() {
      const isOpen = this.detailsElement.hasAttribute('open');

      if (window.matchMedia('(min-width: 990px)').matches && !isOpen) {
        this.open();

        return;
      };

      if (isOpen) {
        this.close();
      }
    }

    onSummaryClick(event) {
      if (window.matchMedia('(min-width: 990px)').matches) {
        event.preventDefault();

        return;
      }

      super.onSummaryClick(event);
    }

    close() {
      if (window.matchMedia('(min-width: 990px)').matches) {
        return;
      }

      super.close();
    }
  }

  customElements.define('footer-accordion', FooterAccordion);
})();
